import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { InputCurrencyConverterVariantType } from '../../../../../components/inputCurrencyConverter/types/inputCurrencyConverterVariantType';
import { InputErrorMessageVariantType } from '../../../../../components/internal/inputErrorMessage/types/inputErrorMessageVariantType';
import { InputHelpMessageVariantType } from '../../../../../components/internal/inputHelpMessage/types/inputHelpMessageVariantType';
import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, FONT, STATE_TOKENS) => ({
    container: {
        display: 'flex',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_200,
        ...STATE_TOKENS.container,
    },
    inputContainer: {
        border_radius: FOUNDATIONS.radius_comp_forms_inputcurrencylarge_radiussize,
        border_style: 'solid',
        border_width: FOUNDATIONS.border_50,
        border: FOUNDATIONS.color_neutral_border_150,
        padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_250}`,
        background_color: FOUNDATIONS.color_comp_forms_input_bg,
        cursor: 'pointer',
        ...STATE_TOKENS.inputContainer,
    },
    affixInputParentContainer: {
        position: 'relative',
        display: 'flex',
        gap: FOUNDATIONS.spacing_200,
        justify_content: 'space-between',
        ...STATE_TOKENS.affixInputParentContainer,
    },
    affixContainer: {
        display: 'inline-flex',
        justify_content: 'center',
        align_items: 'center',
        border_radius: FOUNDATIONS.radius_200,
        background_color: 'transparent',
        ...STATE_TOKENS.affixContainer,
    },
    affix: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FOUNDATIONS.font_weight_paragraph_small_regular,
        color: FOUNDATIONS.color_comp_forms_input_filled_font,
        ...STATE_TOKENS.affix,
    },
    helpMessage: { variant: InputHelpMessageVariantType.REGULAR },
    inputTypography: {
        font_weight: FONT_WEIGHT.font_weight_600,
        font_size: FONT.font_heading_300[DeviceBreakpointsType.DESKTOP].font_size,
        line_height: FONT.font_heading_300[DeviceBreakpointsType.DESKTOP].line_height,
        color: FOUNDATIONS.color_comp_forms_input_filled_font,
        text_overflow: 'ellipsis',
        white_space: 'nowrap',
        ...STATE_TOKENS.helpMessage,
    },
    input: { variant: InputCurrencyConverterVariantType.REGULAR },
    placeholder: {
        font_weight: FONT_WEIGHT.font_weight_600,
        font_size: FONT.font_heading_300[DeviceBreakpointsType.DESKTOP].font_size,
        line_height: FONT.font_heading_300[DeviceBreakpointsType.DESKTOP].line_height,
        color: FOUNDATIONS.color_comp_forms_input_secondaryfont,
        ...STATE_TOKENS.placeholder,
    },
    inputTitle: { variant: InputCurrencyConverterVariantType.REGULAR },
    inputTitleContainer: {
        display: 'flex',
        ...STATE_TOKENS.inputTitleContainer,
    },
    flagAndCurrency: {
        display: 'flex',
        align_items: 'center',
        gap: FOUNDATIONS.spacing_150,
        ...STATE_TOKENS.flagAndCurrency,
    },
    flagIcon: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        color: FOUNDATIONS.color_neutral_font_50,
        ...STATE_TOKENS.flagIcon,
    },
});
export const defaultEmptyFontCommonStyles = (FOUNDATIONS, FONT) => ({
    inputTypography: {
        ...commonStyles(FOUNDATIONS, FONT, {
            inputTypography: { color: FOUNDATIONS.color_comp_forms_input_empty_font },
        }).inputTypography,
    },
    affix: {
        ...commonStyles(FOUNDATIONS, FONT, {
            affix: { color: FOUNDATIONS.color_comp_forms_input_empty_font },
        }).affix,
    },
    placeholder: {
        font_weight: FONT_WEIGHT.font_weight_600,
        font_size: FONT.font_heading_300[DeviceBreakpointsType.DESKTOP].font_size,
        line_height: FONT.font_heading_300[DeviceBreakpointsType.DESKTOP].line_height,
        color: FOUNDATIONS.color_comp_forms_input_secondaryfont,
    },
});
export const disabledFilledCommonStyles = (FOUNDATIONS, FONT) => ({
    ...commonStyles(FOUNDATIONS, FONT, {
        inputContainer: {
            background_color: FOUNDATIONS.color_accent_disabled_bg_100,
            border: FOUNDATIONS.color_accent_disabled_border_100,
            cursor: 'default',
        },
        inputTypography: { color: FOUNDATIONS.color_accent_disabled_font_50 },
        affix: { color: FOUNDATIONS.color_accent_disabled_font_50 },
        placeholder: { color: FOUNDATIONS.color_accent_disabled_font_50 },
    }),
});
export const commonErrorStyles = (FOUNDATIONS, FONT) => ({
    errorMessage: { variant: InputErrorMessageVariantType.REGULAR },
});
//# sourceMappingURL=commonStyles.js.map